import React, { useState } from 'react';
import styled from 'styled-components';
import { FaPlus, FaMinus } from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';

const FAQSectionContainer = styled.section`
  padding: 80px 0;
`;

const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const AccordionContainer = styled.div`
  margin-top: 30px;
`;

const AccordionItem = styled.div`
  margin-bottom: 15px;
  border-radius: ${props => props.theme.borders.radius.regular};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.small};
`;

const AccordionHeader = styled.div`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    background-color: ${props => props.theme.colors.grey[200]};
  }
`;

const AccordionTitle = styled.h4`
  margin: 0;
  color: ${props => props.theme.colors.secondaryColor};
  font-size: ${props => props.theme.fontSizes.medium};
`;

const AccordionIcon = styled.div`
  color: ${props => props.theme.colors.primaryColor};
  font-size: 1rem;
`;

const AccordionContent = styled.div`
  padding: ${props => props.isOpen ? '20px' : '0 20px'};
  background-color: white;
  max-height: ${props => props.isOpen ? '500px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
`;

const AccordionText = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  line-height: 1.7;
  margin: 0;
`;

const FAQSection = ({ title = "Frequently Asked Questions", subtitle = "Quick answers to common questions" }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  const faqs = [
    {
      question: "How can I enroll in the TNPSC exam coaching?",
      answer: "You can enroll by filling out the contact form on this page, calling us at +91 9444108728, or visiting our office during working hours."
    },
    {
      question: "What are the payment options available?",
      answer: "We accept online transfers, UPI payments, and cash payments at our office. Installment options are also available for selected courses."
    },
    {
      question: "Do you offer any scholarships?",
      answer: "Yes, we offer merit-based scholarships for deserving students. Please contact our office for more details on eligibility criteria and application process."
    },
    {
      question: "What is your refund policy?",
      answer: "Refund requests must be made within 7 days of enrollment. A processing fee may be applicable. Please refer to our terms and conditions for complete details."
    }
  ];

  return (
    <FAQSectionContainer>
      <div className="container">
        <SectionHeader 
          title={title} 
          subtitle={subtitle} 
        />
        
        <FAQContainer>
          <AccordionContainer>
            {faqs.map((faq, index) => (
              <AccordionItem key={index}>
                <AccordionHeader onClick={() => toggleAccordion(index)}>
                  <AccordionTitle>{faq.question}</AccordionTitle>
                  <AccordionIcon>
                    {activeIndex === index ? <FaMinus /> : <FaPlus />}
                  </AccordionIcon>
                </AccordionHeader>
                <AccordionContent isOpen={activeIndex === index}>
                  <AccordionText>{faq.answer}</AccordionText>
                </AccordionContent>
              </AccordionItem>
            ))}
          </AccordionContainer>
        </FAQContainer>
      </div>
    </FAQSectionContainer>
  );
};

export default FAQSection;
